import { format } from "date-fns"
/**
 * Convierte un objeto Moment a un objeto Date y lo formatea en 'yyyy-mm-dd'.
 * @param {Object} momentObject - El objeto Moment.
 * @returns {string} - La fecha formateada en 'yyyy-mm-dd'.
 */
export const convertMomentToDateString = (momentObject) => {
  try {
    const dateObject = momentObject._d
    return format(dateObject, 'yyyy-MM-dd')
  } catch (error) {
    console.error(error)
    return ''
  }
}
